<div class="login-container">
  <img
    src="/assets/bg-datasafra.jpg"
    alt="Background DataSafra"
    class="bg-image"
  />

  <div class="login-panel">
    <div class="login-form-container">
      <img src="assets/data-safra-logo.png" alt="DATASAFRA Logo" class="logo" />

      <div>
        <h2>Bem-vindo à Plataforma DataSafra</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field class="full-width">
            <mat-label>E-mail</mat-label>
            <input
              matInput
              name="email"
              type="email"
              [formControl]="loginForm.controls.email"
              placeholder="seuemail@exemplo.com"
              autocomplete="username"
            />
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Senha</mat-label>
            <input
              name="password"
              matInput
              [type]="hide ? 'password' : 'text'"
              [formControl]="loginForm.controls.password"
              placeholder="Sua senha"
              autocomplete="current-password"
            />
            <button
              matIconButton
              matSuffix
              (click)="hide = !hide"
              type="button"
            >
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>

          <div class="button-container">
            <button type="submit" mat-raised-button color="primary">
              Fazer Login
            </button>
          </div>
        </form>

        <div>
          <a (click)="esqueceuSenha()" class="forgot-password-link">
            Primeiro acesso/esqueci minha senha
          </a>
        </div>
        <div class="new-customer-info">
          Ainda não é cliente?
          <a [href]="contactUrl" class="new-customer-link" target="_blank">
            Fale com nossos consultores
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
